import "react-calendar/dist/Calendar.css";

import { MouseEventHandler, useCallback, useState } from "react";
import ReactCalendar, { DateCallback } from "react-calendar";
import { useFormContext, UseFormRegisterReturn } from "react-hook-form";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

import Modal from "~/components/ui/modal";
import { CreateMemberInput } from "~/types/user/user.types";

import styles from "./index.module.scss";

interface Props {
  registrationProps: UseFormRegisterReturn<keyof CreateMemberInput>;
  label: string;
}

const DatePicker = ({ registrationProps, label }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { setValue, getValues } = useFormContext<CreateMemberInput>();

  const handleOpenModal: MouseEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      e.preventDefault();
      setModalOpen(true);
    },
    [setModalOpen]
  );

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const onClickDay: DateCallback = useCallback(
    (date) => {
      setValue("birthDate", date);
      handleCloseModal();
    },
    [setValue, handleCloseModal]
  );

  const birthDate = getValues("birthDate")
    ? new Date(getValues("birthDate"))
    : null;

  const date18YearsAgo = new Date(Date.now());
  date18YearsAgo.setFullYear(date18YearsAgo.getFullYear() - 18);

  return (
    <>
      <div className={styles.inputContainer}>
        <label>{label}</label>
        <input
          {...registrationProps}
          placeholder="dd/mm/yyyy"
          className={styles.input}
          type="date"
          autoComplete="off"
          onClick={handleOpenModal}
        />
        <span>{birthDate?.toLocaleDateString("fr") ?? "dd/mm/yyyy"}</span>
      </div>

      <Modal open={modalOpen} onClose={handleCloseModal} showAnimation="expand">
        <div className={styles.container}>
          <ReactCalendar
            className={styles.calendar}
            tileClassName={styles.day}
            nextLabel={<FiArrowRight />}
            prevLabel={<FiArrowLeft />}
            value={birthDate}
            defaultValue={date18YearsAgo}
            onClickDay={onClickDay}
            maxDate={new Date(Date.now())}
          />
        </div>
      </Modal>
    </>
  );
};

export default DatePicker;
